import axiosInstance, { CustomAxiosRequestConfig } from "../services/axios";
import { Endpoints } from "./endpoint";
import { IConsultation, ICreateConsultationPayload, IEmailConfirmation } from "../types/consultation";

import { QueryObject,dateRange } from "./global";

export const createConsultationApi = async (
  payload: Partial<ICreateConsultationPayload>
) => {
  const res = await axiosInstance.post(
    `${process.env.NEXT_PUBLIC_API}${Endpoints.CONSULTATIONS.CREATE}`,
    payload,
    {
      requiresAuth: false,
    } as CustomAxiosRequestConfig
  );
  return res.data;
};

export const getAllConsultationsApi = async (payload:Partial<QueryObject<{dateRange:dateRange,date:Date,type:string,consultStatus:string}>>) => {
  let url = `${process.env.NEXT_PUBLIC_API}${Endpoints.CONSULTATIONS.CREATE}`;
    const queryParams = [];
  
    if (payload.page !== undefined) {
      queryParams.push(`page=${payload.page}`);
    }
     if(payload.type!==undefined){
      queryParams.push(`type=${payload.type}`)
     }

     if(payload.consultStatus!==undefined){
      queryParams.push(`consultStatus=${payload.consultStatus}`);
     }

    if (payload.limit !== undefined) {
      queryParams.push(`limit=${payload.limit}`);
    }
    if(payload.date!==undefined){
      queryParams.push(`date=${payload.date.toISOString()}`);
    }

    if(payload.dateRange!==undefined){
      
      queryParams.push(`dateRange=${encodeURIComponent(JSON.stringify(payload.dateRange))}`);
    }
    
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
  
    const res = await axiosInstance.get(url);
    return res.data;
};

export const DeleteConsultationApi = async (id:string) => {
  const res = await axiosInstance.delete(
    `${process.env.NEXT_PUBLIC_API}${Endpoints.CONSULTATIONS.CREATE}/${id}`,
    {
      requiresAuth: false,
    } as CustomAxiosRequestConfig
  );
  return res.data;
};

export const ConsultationApi = async (id:string) => {
  const res = await axiosInstance.get(
    `${process.env.NEXT_PUBLIC_API}${Endpoints.CONSULTATIONS.CREATE}/${id}`,
    {
      requiresAuth: false,
    } as CustomAxiosRequestConfig
  );
  return res.data;
};

export const UpdateConsultationApi = async (id: string, payload: Partial<Omit<IConsultation, "_id">>) => {
  const res = await axiosInstance.put(
    `${process.env.NEXT_PUBLIC_API}${Endpoints.CONSULTATIONS.CREATE}/${id}`,
    payload,
    {
      requiresAuth: true,
    } as CustomAxiosRequestConfig
  );
  return res.data;
};


export const ConsultationEmailApi = async ( payload: Partial<Omit<IEmailConfirmation, "userId">>) => {
  const res = await axiosInstance.post(
    `${process.env.NEXT_PUBLIC_API}${Endpoints.CONSULTATIONS.CREATE}/${Endpoints.CONSULTATIONS.EMAILCONFIRM}`,
    payload,
    {
      requiresAuth: true,
    } as CustomAxiosRequestConfig
  );
  return res.data;
};